/* eslint-disable max-len */
import { ICoinPageData } from 'pages/loans/[coin]/assets/page-data/types'
import apeQuestions from 'images/coin-pages/questions/ape.svg'

import { commonLearnMoreData, commonSlidesData } from '../commonPageData'

export const apePage: ICoinPageData = {
  title: 'coin_81',
  description: 'coin_82',
  // description:
  //   'Borrow ApeCoin against Stablecoins.' +
  //   ` Get a stablecoin loan using your APE coin as collateral for ${PERCENTAGES.loan}% APR for an unlimited term.`,
  h1: (t, _, replacePlaceholders) => (
    <span dangerouslySetInnerHTML={{ __html: replacePlaceholders(t('get_instant_coin_loan'), { coin: 'ApeCoin' }) }} />
  ),
  questionsBlock: {
    image: apeQuestions,
    questions: [
      {
        title: 'coin_83',
        answer: 'coin_84',
      },
      {
        title: 'coin_85',
        answer: 'coin_86',
      },
      {
        title: 'coin_87',
        answer: 'coin_88',
      },
      {
        title: 'coin_89',
        answer: 'coin_90',
      },
    ],
  },
  whatIs: {
    ...commonSlidesData('ApeCoin (APE)'),
    text: [],
    paragraphs: [
      {
        title: 'coin_91',
        text: ['coin_93', 'coin_94'],
      },
      {
        title: 'coin_92',
        text: ['coin_95'],
      },
    ],
    ...commonLearnMoreData('ApeCoin (APE)'),
  },
}
